import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_deleteFoodCatering, api_getFoodCaterings } from '../../../api/catering/foodCatering'; // Adjusted import for FoodCatering APIs
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Button from '../../../components/bootstrap/Button';

const Item = ({ item, removeFoodCateringFromTable, index }: any) => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleDeleteFoodCatering = async (foodCateringId: string) => {
		try {
			setLoading(true);
			const res = await api_deleteFoodCatering(foodCateringId);
			if (res.isSuccess) {
				removeFoodCateringFromTable(foodCateringId);
			} else {
				console.error('Failed to delete event type:', res.message);
			}
		} catch (error) {
			console.error('Error deleting event type:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<tr key={index}>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.name}</div> {/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.description}</div> {/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<span
					onClick={() => navigate(`/edit/foodCatering`, { state: item })} // Navigate to edit event type route
					style={{ margin: 10, cursor: 'pointer' }}>
					EDIT
				</span>
				<span
					onClick={() => handleDeleteFoodCatering(item._id)}
					style={{ margin: 10, cursor: 'pointer' }}>
					{loading ? 'Loading..' : 'DELETE'}
				</span>
			</td>
		</tr>
	);
};

const AllFoodCatering = () => {
	const [foodCaterings, setFoodCaterings] = useState<any>([]); // State variable to hold event types
	const [loading, setLoading] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const navigate = useNavigate();
	const tableBodyRef = useRef<HTMLTableSectionElement>(null);

	// Function to fetch event types
	const getFoodCaterings = async (page_no?: number) => {
		const finalPageNo = page_no || pageNo;

		try {
			setLoading(true);
			const res = await api_getFoodCaterings(); // Fetch event types from API

			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					if (page_no === 1) {
						setFoodCaterings(res.data);
						setPageNo(2);
					} else {
						setFoodCaterings([...foodCaterings, ...res.data]);
						setPageNo(pageNo + 1);
					}
				}
			} else {
				console.error('Failed to fetch event types:', res.message);
			}
		} catch (error) {
			console.error('Error fetching event types:', error);
		} finally {
			setLoading(false);
		}
	};

	// Function to remove event type from table
	const removeFoodCateringFromTable = (foodCateringId: string) => {
		setFoodCaterings(foodCaterings.filter((e: any) => e._id !== foodCateringId));
	};

	// Load more event types
	const onLoadMore = () => {
		if (hasMore) {
			getFoodCaterings();
		}
	};

	// Handle filter reset
	const handleFilterReset = () => {
		setFoodCaterings([]);
		setHasMore(true);
		getFoodCaterings(1);
	};

	// Fetch event types on component mount
	useEffect(() => {
		getFoodCaterings();
	}, []);

	// Add scroll event listener to table body
	useEffect(() => {
		tableBodyRef.current?.addEventListener('scroll', (e) => {
			console.log(e);
		});
	}, []);

	return (
		<PageWrapper title={'Food Catering'}>
			<Card stretch>
				<CardHeader borderSize={1}>
					<CardLabel icon='Alarm' iconColor='info'>
						<CardTitle>All Food Catering</CardTitle>
					</CardLabel>
					<CardActions>
						<Button
							onClick={() => navigate('/add/foodCatering')}
							icon='PersonAdd'
							color='primary'
							isLight={true}>
							New Food Catering
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody isScrollable className='table-responsive'>
					<table className='table table-modern'>
						<thead>
							<tr>
								<th>Name</th>
								<th>Description</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{foodCaterings?.map((item: any, index: any) => (
								<Item
									key={index}
									item={item}
									index={index}
									removeFoodCateringFromTable={removeFoodCateringFromTable}
								/>
							))}
						</tbody>
					</table>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							marginBottom: '20px',
						}}>
						{hasMore && (
							<button
								style={{
									border: 'none',
									padding: '10px',
									borderRadius: '10px',
									cursor: 'pointer',
								}}
								onClick={onLoadMore}>
								Load More...
							</button>
						)}
					</div>
				</CardBody>
			</Card>
		</PageWrapper>
	);
};

export default AllFoodCatering;
